import {
  Box,
  Button,
  MenuItem,
  Select,
  Card,
  CardMedia,
  CircularProgress,
  Grid,
  Stack,
  Typography,
  Paper
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import React, { useCallback, useEffect, useState, useMemo } from 'react';
import TitleStackComponent from '../../components/TitleStack/TitleStack';
import { useOkta } from '../../hooks/oktaHook';
import CalanderCadanceImage from '../../assests/images/CalendarCadenceHome.svg';
import ComprehensiveViewImage from '../../assests/images/ComprehensiveView.svg';
import ArrowRightAltOutlined from '@mui/icons-material/ArrowRightAltOutlined';
import Template from './Template';
import ComprehensiveView from './ComprehensiveView';
import { fetchActualTemplateData, fetchCalanderExistanceByBU, updateTaskDetails } from './service';
import { useDispatch, useSelector } from 'react-redux';
import { setCalendarExistance } from '../../redux/Calendar/calendarSlice';
import { hasCommonElement } from '../../utils/Utils';
import { CORE_USER, TPO_ADMIN } from '../../utils/Constants';
import CalendarModal from '../../components/CalendarCards/CalendarModal';
import { viewAllTaskFilters } from './constants';
import { Switcher } from 'pepsico-ds';
import CustomCalendar from '../../components/CalendarCards/CustomCalendar';
import { filterData, getStructuredMonthCalendarData } from './utils';

const CalanderCadancePage = () => {
  const roleToValidate = [TPO_ADMIN, CORE_USER];
  const [showTemplate, setShowTemplate] = useState(false);
  const [loading, setIsLoading] = useState(false);
  const [isCheckCalendaLoading, setIsCheckCalendarLoading] = useState(false);
  const [screenId, setScreenId] = useState('template');
  const [showSetup, setShowSetup] = useState(true);
  const { authState, userDetails } = useOkta();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const isCalendarCreated = useSelector((state) => state.calendar.calendarExistance);
  const taskArrayRx = useSelector((state) => state.calendar.updatedData);
  const comprehensiveData = useSelector((state) => state.calendar.comprehensiveData);
  const [events, setEvents] = useState([]);
  const [eventCategories, setEventCategories] = useState([]);
  const [viewType, setViewType] = useState(0);
  const [filterValue, setFiltervalue] = useState('View All Tasks');
  const [showAssignedToMeOption, setShowAssignedToMeOption] = useState(false);
  const selectedCycleObj = useSelector((state) => state.cycle.selectedCycleObj);

  const {
    accessToken: {
      claims: { FirstName: userName }
    }
  } = authState;

  const { roles: userRoles, email } = userDetails;
  const { search } = useLocation();
  const newParams = new URLSearchParams(search);
  const selectedCycleId = Number(newParams.get('cycleId'));
  const selectedBu = newParams.get('bu');

  const memoizedSelectedBu = useMemo(() => selectedBu, [selectedBu]);

  const handleCalanderStartBtnAction = () => {
    setShowSetup(false);
    setScreenId('template');
    setShowTemplate(true);
  };

  //!: make api call to get if for the bu calender is alreday created or not,
  const getCalenderExistance = useMemo(
    () => async () => {
      try {
        setIsCheckCalendarLoading(true);
        const response = await fetchCalanderExistanceByBU({
          buName: memoizedSelectedBu,
          userName: email,
          cycleId: selectedCycleId
        });
        dispatch(setCalendarExistance(response));
      } catch (error) {
        console.error('Error fetching calendar existence data:', error);
      } finally {
        setIsCheckCalendarLoading(false);
      }
    },
    [memoizedSelectedBu, email]
  );
  useEffect(() => {
    const trimmedEmail = email.trim();
    if (trimmedEmail !== '' && selectedCycleId) {
      getCalenderExistance();
    }
  }, [email]);

  // if already created (will get api response i.e calcreated : boolean) then directly show s=comprehensive view
  useEffect(() => {
    if (isCalendarCreated) {
      setShowSetup(false);
      setShowTemplate(false);
      setScreenId('comprehensive');
    }
  }, [isCalendarCreated]);

  const handleCreateCalanderBtnAction = () => {
    setIsLoading(true);
    const res = createCalanderAPI(taskArrayRx);
    if (res) {
      res.then((res) => {
        setIsLoading(false);
        setScreenId('comprehensive');
        setShowTemplate(false);
      });
    }
  };

  const createCalanderAPI = useCallback(
    async (data) => {
      if (!data) return;
      if (memoizedSelectedBu && email) {
        const payload = {
          buName: memoizedSelectedBu,
          userName: email,
          tasksList: data,
          cycleId: selectedCycleId
        };
        try {
          const response = await updateTaskDetails(payload);
          return response;
        } catch (error) {
          console.error('Error fetching updateTask data:', error);
          setIsLoading(false);
        }
      }
    },
    [memoizedSelectedBu, email]
  );

  const getComprehensiveData = useCallback(async () => {
    const payload = {
      buName: memoizedSelectedBu,
      userEmail: email,
      userRoles,
      tasksList: [],
      cycleId: selectedCycleId
    };
    if (email !== '') {
      try {
        setIsLoading(true);
        const response = await fetchActualTemplateData(payload);
        const assignedToLength = filterData(response, email)?.length > 0;
        setShowAssignedToMeOption(assignedToLength);
        setIsLoading(false);
        const { categoriesLegend, eventsData } = getStructuredMonthCalendarData(comprehensiveData);
        setEventCategories(categoriesLegend);
        setEvents(eventsData);
      } catch (error) {
        console.error('Error fetching template data:', error);
        setIsLoading(false);
      }
    }
  }, [memoizedSelectedBu, email, userRoles]);

  useEffect(() => {
    if (memoizedSelectedBu && selectedCycleId) {
      getComprehensiveData();
    }
  }, [email]);

  const handleUpdateView = (newIndex) => {
    setViewType(newIndex);
  };

  useEffect(() => {
    if (!isModalOpen) {
      const { categoriesLegend, eventsData } = getStructuredMonthCalendarData(comprehensiveData);
      setEventCategories(categoriesLegend);
      setEvents(eventsData);
    }
  }, [comprehensiveData]);

  const setupScreen = () => {
    return (
      <Box sx={{ p: 4 }}>
        <Grid container direction={'row'} justifyContent={'flex-start'} marginTop={'4px'} gap={3}>
          <Card>
            <Box
              sx={{
                maxWidth: '640px',
                minWidth: '260px',
                width: '60vw',
                maxHeight: '620px',
                minHeight: '20vh',
                height: '72vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
              <CardMedia
                data-testid={`svg-calander`}
                component="svg"
                image={CalanderCadanceImage}
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'scale-down' // Ensures that the SVG maintains its aspect ratio
                }}
                alt={'svg-calander-image'}
              />
            </Box>
          </Card>
          <Stack direction="column" sx={{ justifyContent: 'space-between', gap: 0 }}>
            <TitleStackComponent
              title={`Hey ${userName},`}
              titleVariant="h4"
              stackGap={'0.65rem'}
              stackWidth={'100%'}
              subtitle="Start with a template and modify to best suit your teams PO needs"
              descriptions="Looks like you haven't set up your calander cadence yet. It's really simple!"
              showSetup
            />
            <Button
              component="label"
              data-testid="btn-populate-prev"
              role={undefined}
              variant="contained"
              tabIndex={-1}
              endIcon={<ArrowRightAltOutlined />}
              disabled={selectedCycleObj?.['testCycle']}
              sx={{
                fontSize: 14,
                alignItems: 'center',
                position: 'relative',
                maxWidth: 'max-content',
                marginTop: '2rem'
                // top: '50%',
                // left: '50%',
                // transform: 'translate(-50%, -50%)'
              }}
              onClick={handleCalanderStartBtnAction}>
              Create Calendar Cadence
            </Button>
            <Stack sx={{ position: 'relative', height: '100%' }}></Stack>
          </Stack>
        </Grid>
      </Box>
    );
  };

  const showTemplateScreen = () => {
    return (
      <Template
        title={'Project TimeLine'}
        onSubmit={handleCreateCalanderBtnAction}
        onCancel={handleCalanderStartBtnAction}
        submitLoad={loading}
        enableEdit={hasCommonElement(roleToValidate, userRoles)}
      />
    );
  };

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: 'transparent',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027'
    })
  }));

  const loadScreen = () => {
    if (hasCommonElement(roleToValidate, userRoles) && showSetup) return setupScreen();
    if (hasCommonElement(roleToValidate, userRoles) && showTemplate) return showTemplateScreen();
  };

  return (
    <>
      {isCheckCalendaLoading && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100vw'
          }}>
          <CircularProgress />
        </Box>
      )}
      {!isCheckCalendaLoading && (
        <>
          <Grid container>
            {showSetup || showTemplate ? (
              loadScreen()
            ) : viewType == 0 ? (
              <>
                <Grid item xs={6} md={8} style={{ padding: '0px' }}>
                  <Item style={{ backgroundColor: '#f3f7fd' }}>
                    <Stack direction="column" sx={{ p: 3 }}>
                      <Stack
                        sx={{
                          justifyContent: 'space-between',
                          display: 'flex',
                          flexDirection: 'row'
                        }}>
                        <Typography variant="h4" style={{ color: '#3a3a3a' }}>
                          {'Calendar Cadence'}
                        </Typography>
                        <Stack direction={'column'} alignItems="flex-end">
                          {/* Adjusted: allows this block to take available space */}
                          <Typography
                            variant="extraSmall"
                            fontWeight={400}
                            sx={{ color: '#616161' }}>
                            Current BU
                          </Typography>
                          <Typography variant="extraSmall" fontWeight={700}>
                            {selectedBu}
                          </Typography>
                        </Stack>
                      </Stack>
                      <Stack style={{ margin: '4% 1% 1% 5%', textAlign: 'start' }}>
                        <Typography variant="h5" style={{ color: '#3a3a3a' }}>
                          Welcome back! Looks like you left off with Master File Prep.
                        </Typography>
                      </Stack>
                      {showAssignedToMeOption && (
                        <Stack>
                          <Typography
                            style={{
                              fontSize: '14px',
                              fontWeight: 400,
                              color: '#3a3a3a',
                              textAlign: 'start',
                              marginLeft: '18%'
                            }}>
                            Here are the {''}
                            <span
                              onClick={() => {
                                setViewType(1);
                                setFiltervalue(viewAllTaskFilters?.[1]);
                              }}
                              style={{
                                color: '#005cbc',
                                textDecoration: 'underline',
                                cursor: 'pointer'
                              }}>
                              tasks {''}
                            </span>
                            you might want to look into.
                          </Typography>
                        </Stack>
                      )}
                    </Stack>
                    {/* <TitleWithButton showSetup={showSetup} screenId={screenId} /> */}
                    {hasCommonElement(roleToValidate, userRoles) && showSetup && setupScreen()}
                    {hasCommonElement(roleToValidate, userRoles) &&
                      showTemplate &&
                      showTemplateScreen()}
                    {screenId === 'comprehensive' && (
                      <CustomCalendar eventCategories={eventCategories} events={events} />
                    )}
                  </Item>
                </Grid>
                <Grid item xs={6} md={4} zIndex={1}>
                  <Item style={{ borderRadius: '0px', backgroundColor: '#fff !important' }}>
                    <Box
                      style={{
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'center',
                        padding: '10px'
                      }}>
                      <img
                        src={ComprehensiveViewImage}
                        alt="Comprehensive View Image"
                        width={199}
                        height={140}
                      />
                    </Box>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        margin: '0 20px'
                      }}>
                      <Switcher
                        items={['Calendar', 'List']}
                        onUpdate={handleUpdateView}
                        selectedItemIndex={viewType}
                      />
                      <Select
                        value={filterValue}
                        onChange={(e) => setFiltervalue(e.target.value)}
                        variant="standard"
                        disableUnderline
                        sx={{
                          border: '3px solid #d7e5f8',
                          backgroundColor: '#d7e5f8',
                          padding: '2px 4px',
                          height: '32px',
                          width: '185px',
                          borderRadius: '24px',
                          fontSize: '14px',
                          fontWeight: 400,
                          color: '#005cbc'
                        }}>
                        {(!showAssignedToMeOption
                          ? [viewAllTaskFilters?.[0]]
                          : viewAllTaskFilters
                        )?.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </Item>
                  <ComprehensiveView
                    bu={memoizedSelectedBu}
                    userEmail={email}
                    role={userRoles}
                    enableEdit={hasCommonElement(roleToValidate, userRoles)}
                    filterValue={filterValue}
                    setAssignedDataList={(data) => setShowAssignedToMeOption(data)}
                  />
                </Grid>
              </>
            ) : (
              <Grid item xs={12} md={12}>
                <Item style={{ borderRadius: '0px' }}>
                  <Stack direction="column" sx={{ p: 3 }}>
                    <Stack
                      sx={{
                        justifyContent: 'space-between',
                        display: 'flex',
                        flexDirection: 'row'
                      }}>
                      <Typography variant="h4" style={{ color: '#3a3a3a' }}>
                        {'Calendar Cadence'}
                      </Typography>
                    </Stack>
                    <Stack
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        gap: '1rem'
                      }}>
                      <Stack>
                        <Stack style={{ margin: '3% 1% 1% 5%' }}>
                          <Typography
                            variant="h5"
                            style={{
                              color: '#3a3a3a',
                              whiteSpace: 'nowrap' // Prevent wrapping of the text
                            }}>
                            Welcome back! Looks like you left off with Master File Prep.
                          </Typography>
                        </Stack>
                        {showAssignedToMeOption && (
                          <Stack>
                            <Typography
                              style={{
                                fontSize: '14px',
                                fontWeight: 400,
                                color: '#3a3a3a',
                                textAlign: 'start',
                                marginLeft: '18%'
                              }}>
                              Here are the tasks you might want to look into.
                            </Typography>
                          </Stack>
                        )}
                      </Stack>
                      <img
                        src={ComprehensiveViewImage}
                        alt="Comprehensive View Image"
                        width={199}
                        height={140}
                      />
                    </Stack>
                  </Stack>

                  <div
                    style={{ display: 'flex', justifyContent: 'space-between', margin: '0 20px' }}>
                    <Select
                      value={filterValue}
                      onChange={(e) => setFiltervalue(e.target.value)}
                      variant="standard"
                      disableUnderline
                      sx={{
                        border: '3px solid #d7e5f8',
                        backgroundColor: '#d7e5f8',
                        padding: '2px 4px',
                        height: '32px',
                        width: '185px',
                        marginRight: '25px',
                        borderRadius: '24px',
                        fontSize: '14px',
                        fontWeight: 400,
                        color: '#005cbc'
                      }}>
                      {(!showAssignedToMeOption
                        ? [viewAllTaskFilters?.[0]]
                        : viewAllTaskFilters
                      )?.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                    <Switcher
                      items={['Calendar', 'List']}
                      onUpdate={handleUpdateView}
                      selectedItemIndex={viewType}
                    />
                  </div>
                </Item>
                <ComprehensiveView
                  bu={memoizedSelectedBu}
                  userEmail={email}
                  role={userRoles}
                  enableEdit={hasCommonElement(roleToValidate, userRoles)}
                  filterValue={filterValue}
                  setAssignedDataList={(data) => setShowAssignedToMeOption(data)}
                />
              </Grid>
            )}
          </Grid>
          <CalendarModal
            open={isModalOpen}
            handleClose={() => setIsModalOpen(!isModalOpen)}
            data={[]}
            selectedTaskId={''}
            screenId={''}
          />
        </>
      )}
    </>
  );
};

export default CalanderCadancePage;
